import Header from "../../../layouts/AuthLayout/header/header";
import DashboardSection from "./dashboard-section";

export default function DashboardPage() {
  return (
    <>
      {/* <div id="ec-overlay">
    <span className="loader_img" />
  </div> */}
      {/* Header start  */}
      <Header />
      {/* Header End  */}
      {/* Vendor dashboard section */}
      <DashboardSection />
      {/* End Vendor dashboard section */}
    </>
  );
}
